import { RacingApi } from '../../api/index'

export default class RacingManager {
  getAvailableDates (signal = null) {
    return RacingApi.getAvailableDates({ signal })
  }

  getMeetsByDate (isoDate, signal = null) {
    return RacingApi.getMeetsByDate({ isoDate, signal })
  }

  getFutureMeetings (fromIsoDate, toIsoDate, signal = null) {
    return RacingApi.getFutureMeetings({ fromIsoDate, toIsoDate, signal })
  }

  getRaceById (raceId, signal = null) {
    return RacingApi.getRaceById({ raceId, signal })
  }

  getLegRaceById (raceId, signal = null) {
    return RacingApi.getLegRaceById({ raceId, signal })
  }

  getOutcomeById (outcomeId, signal = null) {
    return RacingApi.getOutcomeById({ outcomeId, signal })
  }

  getSameRaceMultiRunners (raceId, signal = null) {
    return RacingApi.getSameRaceMultiRunners({ raceId, signal })
  }

  getSameRaceMultiOutcome (data, signal = null) {
    return RacingApi.getSameRaceMultiOutcome({ data, signal })
  }

  getCombinedOutcome (data, signal = null) {
    return RacingApi.getCombinedOutcome({ data, signal })
  }

  getExoticMarketOutcome (data, signal = null) {
    return RacingApi.getExoticMarketOutcome({ data, signal })
  }

  getMultilegsOutcome (data, signal = null) {
    return RacingApi.getMultilegsOutcome({ data, signal })
  }

  getBasicRunnersInfo (data, signal = null) {
    return RacingApi.getBasicRunnersInfo({ data, signal })
  }

  getRaceOddsHistories (raceId, signal = null) {
    return RacingApi.getRaceOddsHistories({ raceId, signal })
  }

  getRaceStatic (raceId, signal = null) {
    return RacingApi.getRaceStatic({ raceId, signal })
  }

  getNextRaces (signal = null) {
    return RacingApi.getNextRaces({ signal })
  }
}
